import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const TransportReportSection = "/reports/omi/transport-report";

export const TransportReportListPath = TransportReportSection;

export enum TransportReportListUrlFiltersEnum {
  query = "query",
  orderDateFrom = "orderDateFrom",
  orderDateTo = "orderDateTo",
  tenantType = "tenantType",
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo"
}

export enum TransportReportListUrlFiltersWithMultipleValues {
  mall = "mall",
  brand = "brand",
  deliveryType = "deliveryType",
  orderCourier = "orderCourier"
}

export type TransportReportListUrlDialog = "download" | TabActionDialog;
export type transportReportListUrlFilters = Filters<
  TransportReportListUrlFiltersEnum
> &
  FiltersWithMultipleValues<TransportReportListUrlFiltersWithMultipleValues>;

export type TransportReportUrlQueryParams = ActiveTab &
  transportReportListUrlFilters &
  BulkAction &
  Dialog<TransportReportListUrlDialog> &
  Pagination &
  SingleAction;

export const transportReportListUrl = (
  params?: TransportReportUrlQueryParams
) => TransportReportListPath + "?" + stringifyQs(params);
